import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'handsontable/styles/handsontable.min.css';
import 'handsontable/styles/ht-theme-main.min.css';
import '@/assets/ant/styles.scss';

import {createApp} from 'vue';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import {registerAllModules} from 'handsontable/registry';
import {createPinia} from 'pinia';

import {keycloakAPI} from '@/assets/keycloak';

import App from './App.vue';
import {getRouter, initRouter} from './router';
import {install as VueMonacoEditorPlugin} from '@guolao/vue-monaco-editor';

registerAllModules();

keycloakAPI.init().then(() => {
  initRouter();
  createApp(App)
    .use(createPinia())
    .use(VueMonacoEditorPlugin, {
      paths: {
        vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.43.0/min/vs',
      },
    })
    .use(getRouter())
    .mount('#app');
});

dayjs.extend(LocalizedFormat);
